import { render, staticRenderFns } from "./OrderTemplate.vue?vue&type=template&id=6b4d7bd8&scoped=true"
import script from "./OrderTemplate.vue?vue&type=script&lang=js"
export * from "./OrderTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4d7bd8",
  null
  
)

export default component.exports